
export const parties = ['Just me', '2 guests', 'Family', 'Up to 12 guests', 'Larger party'];

export const transportOptions = [
  'Private jet',
  'Chauffeur',
  'Self-drive car',
  'Yacht',
  'Helicopter',
  'Jet + chauffeur',
  'Jet + yacht',
  'Helicopter + yacht',
  'Let Superluxury plan it',
  "I'll get there myself",
];
// Starts the separated closing group in the list
export const transportUndecided = 'Let Superluxury plan it';

// Written as the thing itself, so a visitor can picture it — not a service category
export const needOptions = [
  'Staffed villa',
  'Penthouse suite',
  'Yacht with crew',
  'Supercar delivered',
  'Chauffeur on call',
  'Impossible tables',
  'Private chef',
  'Paddock passes',
  'Club table',
  'Private party',
  'Discreet security',
  'Spa, closed for you',
  'Boutique after hours',
  'Trusted nanny',
  '24/7 assistant',
  'Off-market home',
  'Something unusual',
];

export const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const seasons = [
  { label: 'Spring', range: 'Mar — May', months: ['Mar', 'Apr', 'May'] },
  { label: 'Summer', range: 'Jun — Aug', months: ['Jun', 'Jul', 'Aug'] },
  { label: 'Autumn', range: 'Sep — Nov', months: ['Sep', 'Oct', 'Nov'] },
  { label: 'Winter', range: 'Dec — Feb', months: ['Dec', 'Jan', 'Feb'] },
];
